export const isFeatureActive = (features, serviceName, subService) => {
    const item = features?.find(
      (f) =>
        f.serviceName?.toLowerCase() === serviceName?.toLowerCase() &&
        f.subService?.toLowerCase() === subService?.toLowerCase() &&
        f.isFeatureEnabled?.toLowerCase() === "active"
    );
    return Boolean(item);
  };


  export const isFeatureServiceActive = (features, serviceName, subService) => {
    const item = features?.find(
      (f) =>
        f.serviceName?.toLowerCase() === serviceName?.toLowerCase() &&
        f.subService?.toLowerCase() === subService?.toLowerCase() &&
        f.serviceStatus?.toLowerCase() === "active"
    );
    return Boolean(item);
  };

   export const getSettlementDisplayName = (features, serviceName, subService) => {
    const item = features?.find(
      (f) =>
        f.serviceName?.toLowerCase() === serviceName?.toLowerCase() &&
        f.subService?.toLowerCase() === subService?.toLowerCase() &&
        f.serviceStatus?.toLowerCase() === "active"
    );
    return item?.displayLable;
  };

  export const getTodayDate = () =>{
    return new Date().toISOString().split("T")[0]
  }


  
  